module.exports = stream-browserify;